import { render, staticRenderFns } from "./k-pager.vue?vue&type=template&id=ba13771e&lang=pug&"
import script from "./k-pager.vue?vue&type=script&lang=js&"
export * from "./k-pager.vue?vue&type=script&lang=js&"
import style0 from "./k-pager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba13771e')) {
      api.createRecord('ba13771e', component.options)
    } else {
      api.reload('ba13771e', component.options)
    }
    module.hot.accept("./k-pager.vue?vue&type=template&id=ba13771e&lang=pug&", function () {
      api.rerender('ba13771e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-pager.vue"
export default component.exports